module.exports = "/static/media/addContact.467a05ae.svg";